var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"router-wallet-title"},[_c('div',{staticClass:"wallet-back"},[_c('i',{staticClass:"el-icon-arrow-left",on:{"click":_vm.turnBack}})]),_c('div',{staticClass:"wallet-right"},[_c('WalletTitle')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }